exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".next>span[data-v-1a43bd0c]{float:right}.next>span[data-v-1a43bd0c],.previous>span[data-v-1a43bd0c]{margin-top:8px;cursor:pointer;color:#fff;font-weight:700}.next[data-v-1a43bd0c],.previous[data-v-1a43bd0c]{border-right:1px solid #fff;display:flex;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a43bd0c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/report/ReportWizardNavigation.vue
// module id = 845
// module chunks = 0